export const EXPORT_FILE_REQUEST = 'EXPORT_FILE_REQUEST';
export const EXPORT_FILE_SUCCESS = 'EXPORT_FILE_SUCCESS';
export const EXPORT_FILE_ERROR = 'EXPORT_FILE_ERROR';

export const SEND_REPORT_REQUEST = 'SEND_REPORT_REQUEST';
export const SEND_REPORT_SUCCESS = 'SEND_REPORT_SUCCESS';
export const SEND_REPORT_ERROR = 'SEND_REPORT_ERROR';

export const SET_DELIVERED_REQUEST = 'SET_DELIVERED_REQUEST';
export const SET_DELIVERED_SUCCESS = 'SET_DELIVERED_SUCCESS';
export const SET_DELIVERED_ERROR = 'SET_DELIVERED_ERROR';
